<template>
  <div class="address-list">
    <div class="btn-primary sm-radius" @click="addNew">
      <Icon name="plus" />{{ $t('addressPop.add') }}
    </div>
    <div class="mg-t-20">
      <AddressItem v-for="value in addressList" :key="value.id" :dataObj="value"
        :isSelected="selectedData.id === value.id" @change="onChange" @edit="onEdit" @delete="onDelete">
      </AddressItem>
    </div>
    <div class="address-list__footer">
      <div class="btn-primary" @click="confirm">
        {{ $t('confirm') }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { Icon, Dialog } from 'vant';
import AddressItem from './AddressItem.vue'
export default {
  name: 'AddressList',
  components: {
    AddressItem,
    Icon
  },
  props: {
    defaultSelectId: {
      type: [Number, String],
      default: ''
    }
  },
  computed: {
    ...mapState({
      addressList: state => state.user.addressList,
    })
  },
  mounted() {
    this.selectedData = this.addressList.find(item => item.id === this.defaultSelectId) || {};
  },
  data() {
    return {
      selectedData: {},
    }
  },
  methods: {
    addNew() {
      this.$emit('addNew')
    },
    confirm() {
      if (!this.selectedData || !this.selectedData.id) {
        return this.$toast(this.$t('addressPop.noSelectAddress'));
      }
      this.$emit('change', {
        data: this.selectedData
      });
    },
    onChange({ data }) {
      this.selectedData = data;
    },

    onEdit({ data }) {
      this.$emit('edit', { data });
    },
    onDelete({ data }) {
      Dialog.confirm({
        title: this.$t('addressPop.deleteTitle'),
        message: this.$t('addressPop.deleteConfirm'),
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
      })
        .then(() => {
          this.$store.dispatch("user/deleteAddress", {
            id: data.id
          }).then((res) => {
            if (res.code === 'Success') {
              this.$emit('delete', {
                data
              });
            }
          });
        });
    }
  }
}
</script>

<style lang="less" scoped>
.address-list {
  position: relative;
  height: auto;
  padding: 18px 0 0;
  box-sizing: border-box;

  &__footer {
    position: sticky;
    z-index: 9;
    bottom: 0;
    padding: 24px 0 0;
    width: 100%;
    background: var(--bg-color-gray);

    .btn-primary {
      border-radius: 14px;
    }
  }
}

.sm-radius {
  box-shadow: none;
}
</style>
